import { Component, Injector, OnInit } from "@angular/core";
import { Autobind } from "@common/lib/autobind.decorator/autobind.decorator";
import { ErrorHandlingUtilities } from "@common/lib/utilities/error-handling-utilities";
import { AdaptCommonDialogService } from "@common/ux/adapt-common-dialog/adapt-common-dialog.service";
import { BaseRoutedComponent } from "@common/ux/base-routed.component";
import { lastValueFrom } from "rxjs";
import { StakeholderServicesService } from "../stakeholder-services.service";

interface IOrphanUser {
    Id: number;
    Value: string;
}

@Component({
    selector: "adapt-delete-orphan-users",
    templateUrl: "./delete-orphan-users-page.component.html",
    standalone: false,
})
export class DeleteOrphanUsersComponent extends BaseRoutedComponent implements OnInit {
    public users?: IOrphanUser[];
    public error?: string;

    public constructor(
        private stakeholderServicesService: StakeholderServicesService,
        private commonDialogService: AdaptCommonDialogService,
        injector: Injector,
    ) {
        super(injector);
    }

    public ngOnInit() {
        this.notifyActivated();
    }

    @Autobind
    public async doCheck() {
        this.error = undefined;

        try {
            this.users = await this.stakeholderServicesService.getOrphanUsers();
        } catch (e) {
            this.error = ErrorHandlingUtilities.getHttpResponseMessage(e);
        }
    }

    @Autobind
    public async doDelete() {
        this.error = undefined;

        try {
            await this.stakeholderServicesService.deleteOrphanUsers();
            await lastValueFrom(this.commonDialogService.showMessageDialog("Delete Ok", "Orphan users were deleted successfully"));
            this.users = [];
        } catch (e) {
            this.error = ErrorHandlingUtilities.getHttpResponseMessage(e);
        }
    }
}
